<table class="interview-details">
    @if(!isOnline) {
    <tr>
        <td>Location</td>
        <td>{{location}}</td>
    </tr>
    }
    @if(dateString) {
    <tr>
        <td>Date</td>
        <td>{{dateString}}</td>
    </tr>
    }
    @if(timeString) {
    <tr>
        <td>Time</td>
        <td>{{timeString}} {{timezone}}</td>
    </tr>
    }
    <tr>
        @if(!isHomePage) {
        <td>Notes</td>
        <td>{{notes}}</td>
        } @else {
        <td>Interviewer</td>
        <td>{{interviewerName}}</td>
        }
    </tr>
</table>